<app-loading-bar />

<div class="pmdf-shell-grid bg-pmdf-bg-page h-screen w-screen overflow-hidden"
     [class.mobile-sidebar-active]="layout.isMobile() && layout.isSidenavExpanded()"
     [class.mobile-quickpanel-active]="layout.isMobile() && layout.quickpanelOpened()">

  <app-header class="shell-header z-20" />

  @if (layout.isMobile() && layout.isSidenavExpanded()) {
    <div @fadeIn
         class="fixed inset-0 bg-black/50 z-40 backdrop-blur-[2px]"
         (click)="layout.toggleSidenav()"></div>
  }

  @if (layout.isMobile() && layout.quickpanelOpened()) {
    <div @fadeIn
         class="fixed inset-0 bg-black/50 z-50 backdrop-blur-[2px]"
         (click)="layout.toggleQuickpanel()"></div>
  }

  <aside class="shell-sidebar bg-pmdf-primary text-white z-50 shadow-2xl overflow-hidden"
         [style.width]="layout.isSidenavExpanded() ? '260px' : '72px'">
    <app-sidebar />
  </aside>

  <main class="shell-content p-pmdf-4 md:p-pmdf-6 overflow-y-auto relative"
        [@routeAnimation]="getRouteAnimationData()">
    <router-outlet />

    @if (layout.fabConfig().visible) {
      <button @scaleIn
              class="fixed bottom-20 right-6 md:bottom-12 md:right-12 w-14 h-14 bg-pmdf-warning text-pmdf-primary rounded-full shadow-xl flex items-center justify-center hover:scale-110 active:scale-95 transition-all duration-200 z-30"
              (click)="layout.fabConfig().action()"
              [title]="layout.fabConfig().label">
        <mat-icon class="icon-filled">{{ layout.fabConfig().icon }}</mat-icon>
      </button>
    }
  </main>

  <app-quickpanel class="shell-quick"
                  [class.z-30]="!layout.isMobile()"
                  [class.z-[60]]="layout.isMobile()"
                  [style.width]="!layout.isMobile() ? (layout.quickpanelOpened() ? '320px' : '0px') : ''"
                  [class.overflow-hidden]="!layout.quickpanelOpened() && !layout.isMobile()" />

  <app-footer class="shell-footer z-20" />

  <app-navigation class="shell-nav z-20" />
</div>
